module.exports = __webpack_public_path__ + "media/images/closet_default-4adf8d7c2f7384efbb492054fcdc50a6.jpg";